// extracted by mini-css-extract-plugin
module.exports = {"oferta":"oferta-module--oferta--2Avpc","iconbox":"oferta-module--iconbox--UE0Sr","item":"oferta-module--item--ZfJj_"};